import { useParams } from "react-router-dom"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useAuth } from "@/hooks/useAuth"
import useCurrentUser from "@/hooks/use-current-user"
import { hasReadPermission } from "@/lib/admin-permissions"

export default function WaterEfficiencyPage() {
  const { councilId } = useParams()
  const currentCouncilId = councilId ? Number(councilId) : undefined
  const { user } = useAuth()
  const { hasRole } = useCurrentUser()
  const canReadWaterEfficiency =
    hasRole("super_admin") ||
    hasReadPermission(user?.permissions, "water_efficiency", currentCouncilId)

  if (!canReadWaterEfficiency) {
    return (
      <div className="rounded-lg border bg-card p-6">
        <h2 className="text-xl font-semibold">Access denied</h2>
        <p className="mt-2 text-muted-foreground">
          You need Water Efficiency read permission to view this page.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Water Efficiency</h1>
        <p className="text-muted-foreground">Premium water efficiency insights</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Water Efficiency</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Water Efficiency reporting is a paid add-on. Contact Water Bureau to enable this
            feature.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
